import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import { Row, Col, Image } from "react-bootstrap";
import PageHeader from "../PageHeader/PageHeader";
import PageSectionHeader from "../PageSectionHeader/PageSectionHeader";

import PageSection from "../PageSection/PageSection";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";

const DreamFestGallary = () => {
	const [currentBreakPoint, setCurrentBreakPoint] = useState("");

	useEffect(() => {
		bsBreakpoints.init();
		setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

		const handleBreakPoint = (event) => {
			setCurrentBreakPoint(event.detail);
		};

		window.addEventListener("new.bs.breakpoint", handleBreakPoint);

		return () => {
			window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
		};
	}, []);

	const descriptionClasses = classNames("mb-4 text-center text-text-color", {
		"font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
	});

	return (
		<PageSection>
			<PageSection>
				<ResponsivePageHeader title="Gallary" />
				<Row className="justify-content-left">
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (1).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (2).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (3).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (4).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (5).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (6).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (7).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (8).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={require("../../assets/dream-fest/dreamfest (9).jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (10).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (11).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (12).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (13).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (14).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (15).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-2">
						<Image
							src={
								require("../../assets/dream-fest/dreamfest (16).jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
				</Row>
			</PageSection>
		</PageSection>
	);
};

export default DreamFestGallary;
